import { Component, OnDestroy, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { UrlService } from 'src/app/share/services/url.service';
import { ConfigService } from '../../services/config.service';
import { PopupService } from '../../services/popup.service';
import { ApiService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';
import { Geohelper } from '../../helper/geoHelper';
import { DxAccordionComponent } from 'devextreme-angular/ui/accordion';
import { LanguageService } from '../../services/language.service';
import { IMarkerOptions, MapOsmComponent } from '../map-osm/map-osm.component';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnDestroy, AfterViewInit {
  @ViewChild('resultAccordion', { static: false }) resultAccordion: DxAccordionComponent;
  @ViewChild('map', { static: false }) map: MapOsmComponent;

  @HostListener('window:resize')
  onResize() {
    this.setScrollViewHeight();
  }

  subscription_get_externSearchQueryParams: Subscription;
  subscription_get_externSelectedIdsQueryParams: Subscription;

  traeger: any[];
  filteredResults: any[] = [];
  accordionSelectedItems = [];
  selectedIds: number[] = [];
  emptyExtendedSearch: any[] = [{}];
  betreuungsZeitDataSource: any = undefined;
  extSearchHidden: boolean = true;

  formData: any = {};
  isAccordeonOpen: boolean = false;
  wochentage: any = null;
  addressLat: number;
  addressLon: number;
  mapSearchRadius: number;
  filterText: string = '';
  rangeSliderTimeout: any;
  isInit: boolean = false;
  // anmeldeButtonText: string = '';
  mapZoomLevel: number;

  marker_icon_center: string = 'assets/marker-ownLocation.png';
  marker_icon_selected_open: string = 'assets/marker-open-selected.png';
  marker_icon_selected_notOpen: string = 'assets/marker-closed-selected.png';
  marker_icon_notSelected_open: string = 'assets/marker-open.png';
  marker_icon_notSelected_notOpen: string = 'assets/marker-closed.png';
  marker_icon_selected_open_header: string = 'assets/marker-open-selected-small.png';
  marker_icon_selected_notOpen_header: string = 'assets/marker-closed-selected-small.png';

  content: any;
  filter: any;
  page_container: any;

  mouseX: number;
  mouseY: number;

  constructor(
    private urlService: UrlService,
    private apiService: ApiService,
    public configService: ConfigService,
    private popupService: PopupService,
    private storageService: StorageService,
    private languageService: LanguageService
  ) {
    this.onFilterValueChanged = this.onFilterValueChanged.bind(this);
    this.getTraeger = this.getTraeger.bind(this);
    this.setFilterText = this.setFilterText.bind(this);
    this.onBetreuungsArtValueChanged = this.onBetreuungsArtValueChanged.bind(this);
    this.changeFilter = this.changeFilter.bind(this);
    this.onClickKindExtSearch = this.onClickKindExtSearch.bind(this);
    this.setScrollViewHeight = this.setScrollViewHeight.bind(this);

    this.setInitialCurrentPos();

    this.traeger = this.configService.traeger;
    this.wochentage = this.configService.wochentage;
    this.mapSearchRadius = configService.getGlobalSettingAsNumber('mapSearchRadius');
    this.mapZoomLevel = configService.getGlobalSettingAsNumber('mapZoomLevel');

    this.subscription_get_externSearchQueryParams = this.urlService.get_externSearchQueryParams.subscribe((paras) => {
      if (paras !== null && paras !== undefined) {
        this.formData = paras;
        this.setFilterText();
        if (
          paras.meinStandortLat !== undefined &&
          paras.meinStandortLat !== null &&
          paras.meinStandortLon !== undefined &&
          paras.meinStandortLon !== null
        ) {
          this.addressLat = paras.meinStandortLat;
          this.addressLon = paras.meinStandortLon;
          this.storageService.saveToLocale('position', { lat: paras.meinStandortLat, lon: paras.meinStandortLon });

          this.load();
        }
      }
    });

    this.subscription_get_externSelectedIdsQueryParams = this.urlService.get_externSelectedIdsQueryParams.subscribe((ids) => {
      if (ids !== null && ids !== undefined && ids.length > 0) {
        this.selectedIds = ids;
      } else {
        this.selectedIds = [];
      }

      this.colorizeMarker();

      // if (this.selectedIds !== null && this.selectedIds !== undefined && this.selectedIds.length > 0) {
      //   this.anmeldeButtonText = ' (' + this.selectedIds.length + ')';
      // }
      // else {
      //   this.anmeldeButtonText = '';
      // }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.content = window.document.getElementById('search-page-result-container');
      this.filter = window.document.getElementById('search-page-top-container');
      this.page_container = window.document.getElementById('app-page-container');
      this.setScrollViewHeight();
    }, 50);

    this.isInit = true;

    this.map.getAddressFromLatLon(this.addressLat, this.addressLon, (address) => {
      if (address !== null) {
        this.formData.meinStandort = address.display_name;
      } else {
        this.formData.meinStandort = '';
      }
      if (this.formData.searchBetreuungsArt !== null && this.formData.searchBetreuungsArt !== undefined) {
        this.betreuungsZeitDataSource = this.configService
          .getKatalog('BetreuungsZeitKatalog')
          .filter((x) => x.beziehungen.includes(this.formData.searchBetreuungsArt));
      }

      this.load();
      this.map.setZoom(this.mapZoomLevel);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription_get_externSearchQueryParams) {
      this.subscription_get_externSearchQueryParams.unsubscribe();
    }

    if (this.subscription_get_externSelectedIdsQueryParams) {
      this.subscription_get_externSelectedIdsQueryParams.unsubscribe();
    }
  }

  load() {
    if (!this.isInit) {
      return;
    }

    this.filteredResults = [];

    this.apiService.post<any>(RouteKeys.Extern.get_search, this.formData).subscribe({
      next: (response) => {
        response.forEach((dbKita) => {
          let geoHelper = new Geohelper();
          let distance = geoHelper.getDistanceBetweenTwoPoints(this.addressLat, this.addressLon, dbKita.lat, dbKita.lon);
          dbKita.distance = distance.toFixed(1);
          dbKita.isSelected = this.getIsSelected(dbKita.id);
        });

        if (this.map !== undefined && this.map !== null) {
          this.map.removeAllMarker();
        }

        // Marker
        response.sort((x, y) => {
          return Number(x.isSelected) - Number(y.isSelected);
        });

        let i = 100;
        response.forEach((dbKita) => {
          if (dbKita.distance <= this.mapSearchRadius) {
            this.addKitaMarker(dbKita, i);
            i++;
          }
        });

        // Liste
        const response2 = JSON.parse(JSON.stringify(response)); //remove object reference
        response2.sort((a, b) => a.distance - b.distance);

        const results: any = [];
        response2.forEach((dbKita) => {
          if (dbKita.distance <= this.mapSearchRadius) {
            results.push(dbKita);
          }
        });

        if (results.length > 0) {
          results[0].isAccOpen = true;
        }

        this.filteredResults = results;
        setTimeout(() => {
          this.colorizeMarker();
        }, 100);
      },
      error: (err) => {
        throw err;
      },
    });

    let position: any = this.storageService.getFromLocale('position');
    if (position === null) {
      position = {
        lat: this.configService.getGlobalSettingAsNumber('defaultLatitude'),
        lon: this.configService.getGlobalSettingAsNumber('defaultLongitude'),
      };
      this.storageService.saveToLocale('position', position);
    }
  }

  addKitaMarker(kita, zIndex) {
    let popupDetails: string;
    popupDetails =
      '<p>' +
      '<b>' +
      kita.einrichtungsName +
      '</b></br></br>' +
      kita.strasse +
      ' ' +
      kita.hnr +
      kita.hnrZusatz +
      '</br>' +
      kita.plz +
      ' ' +
      kita.ort +
      '</br></br>';
    if (kita.distance) {
      popupDetails =
        '<p>' +
        '<b>' +
        kita.einrichtungsName +
        '</b></br></br>' +
        kita.strasse +
        ' ' +
        kita.hnr +
        kita.hnrZusatz +
        '</br>' +
        kita.plz +
        ' ' +
        kita.ort +
        '</br></br>' +
        this.languageService.translate('distance') +
        ': ' +
        kita.distance +
        ' km</br>';
    }

    let image = '';
    if (!this.selectedIds.includes(kita.id)) {
      if (kita.isAccOpen === true) {
        image = this.marker_icon_notSelected_open;
      } else {
        image = this.marker_icon_notSelected_notOpen;
      }
    } else {
      if (kita.isAccOpen === true) {
        image = this.marker_icon_selected_open;
      } else {
        image = this.marker_icon_selected_notOpen;
      }
    }

    let markerOptions: IMarkerOptions = {
      lat: kita.lat,
      lon: kita.lon,
      title: kita.einrichtungsName,
      draggable: false,
      iconUrl: image,
      popupDetails: popupDetails,
      zIndexOffset: zIndex,
      closeButton: false,
      onClick: () => {},

      onDragend: () => {},
    };

    kita.maerkerId = this.map.addMarker(markerOptions);
  }

  onDetailsClick(item) {
    this.popupService.showDetailPopup(item);
  }

  onItemTitleClick(e) {
    if (e.itemData.isAccOpen === undefined || e.itemData.isAccOpen === null || e.itemData.isAccOpen === false) {
      e.itemData.isAccOpen = true;
    } else {
      e.itemData.isAccOpen = false;
    }

    this.setItemColor(e.itemData);
  }

  moveAddDepartment(rootElement: Element) {
    var rect = rootElement.getBoundingClientRect();

    var div = document.createElement('div');

    var div_icon = document.createElement('div');
    div_icon.classList.add('dx-icon-check');
    let textNode = document.createTextNode('Hinzugefügt');

    div.appendChild(div_icon);
    div.appendChild(textNode);

    let width = rect.right - rect.left;
    let height = rect.bottom - rect.top;
    div.style.width = width + 'px';
    div.style.height = height + 'px';

    document.body.appendChild(div);
    div.style.left = rect.left + 'px';
    div.style.top = rect.top + 'px';
    div.classList.add('moving-container-add');

    setTimeout(() => {
      div.classList.add('move-add');
    }, 5);

    setTimeout(() => {
      document.body.removeChild(div);
    }, 2000);
  }

  moveRemoveDepartment() {
    var div = document.createElement('div');
    var div_icon = document.createElement('div');
    div_icon.classList.add('dx-icon-trash');
    let textNode = document.createTextNode('Entfernt');

    div.appendChild(div_icon);
    div.appendChild(textNode);
    document.body.appendChild(div);
    div.style.right = '20px';
    div.style.top = '100px';
    div.style.width = '100px';
    div.style.height = '36px';
    div.classList.add('moving-container-remove');

    setTimeout(() => {
      div.classList.add('move-remove');
    }, 5);

    setTimeout(() => {
      document.body.removeChild(div);
    }, 1000);
  }

  onSelectClick(e, item) {
    if (!this.selectedIds.includes(item.id)) {
      this.selectedIds.push(item.id);

      this.moveAddDepartment(e.element);
    } else {
      this.selectedIds = this.selectedIds.filter((x) => x !== item.id);
      this.moveRemoveDepartment();
    }

    this.setItemColor(item);

    this.urlService.refreshQueryParams({
      i: this.selectedIds.join(','),
    });
  }

  onOpenCloseClick() {
    if (this.isAccordeonOpen) {
      this.accordionSelectedItems = [];
      this.isAccordeonOpen = false;
    } else {
      this.accordionSelectedItems = this.filteredResults;
      this.isAccordeonOpen = true;
    }

    for (let index = 0; index < this.filteredResults.length; index++) {
      const item = this.filteredResults[index];
      item.isAccOpen = this.isAccordeonOpen;
      this.setItemColor(item);
    }
  }

  getIsSelected(id: number) {
    const exist = this.selectedIds.find((x) => x === id);
    return exist !== null && exist !== undefined;
  }

  getMarkerImageForHeader(id: number): string {
    const exist = this.filteredResults.find((x) => x.id === id);
    if (exist !== null && exist !== undefined) {
      if (exist.isAccOpen === true) {
        return this.marker_icon_selected_open_header;
      } else {
        return this.marker_icon_selected_notOpen_header;
      }
    } else {
      return '';
    }
  }

  getTraeger(id: number) {
    let tr = this.configService.getTraeger().find((x) => x.key === id);
    if (tr !== undefined) {
      return tr.value;
    }
    return '';
  }

  setFilterText() {
    this.filterText = '';
    if (this.formData.searchBetreuungsArt !== '' && this.formData.searchBetreuungsArt !== undefined) {
      let ea = this.configService.getKatalog('BetreuungsArtKatalog').find((x) => x.id === this.formData.searchBetreuungsArt);
      if (ea !== undefined) {
        this.filterText =
          this.filterText.trim() +
          (this.filterText.trim() !== '' ? ',  ' : '') +
          this.languageService.translate('careType') +
          ' = "' +
          ea.bezeichnung +
          '"';
      }
    }
    if (this.formData.searchBetreuungsZeit !== '' && this.formData.searchBetreuungsZeit !== undefined) {
      let ba = this.configService.getKatalog('BetreuungsZeitKatalog').find((x) => x.id === this.formData.searchBetreuungsZeit);
      if (ba !== undefined) {
        this.filterText =
          this.filterText.trim() +
          (this.filterText.trim() !== '' ? ',  ' : '') +
          this.languageService.translate('careTime') +
          ' = "' +
          ba.bezeichnung +
          '"';
      }
    }
    if (this.formData.traegerId !== null && this.formData.traegerId !== undefined) {
      this.filterText =
        this.filterText.trim() +
        (this.filterText.trim() !== '' ? ',  ' : '') +
        this.languageService.translate('holder') +
        ' = "' +
        this.getTraeger(this.formData.traegerId) +
        '"';
    }
    if (this.formData.einrichtungsName !== '' && this.formData.einrichtungsName !== undefined) {
      this.filterText =
        this.filterText.trim() +
        (this.filterText.trim() !== '' ? ',  ' : '') +
        this.languageService.translate('institution') +
        ' = "' +
        this.formData.einrichtungsName +
        '"';
    }
  }

  setScrollViewHeight() {
    let padding =
      window.document.documentElement.clientWidth <= 720
        ? window.document.documentElement.clientHeight * 0.05
        : window.document.documentElement.clientHeight * 0.06;

    if (this.content && this.page_container && this.filter) {
      if (window.document.documentElement.clientWidth > 1200) {
        this.content.style.height = this.page_container.clientHeight - padding - this.filter.clientHeight - 15 + 'px';
      } else {
        this.content.style.height = this.page_container.clientHeight - padding - this.filter.clientHeight - 55 + 'px';
      }
    }
  }

  onContentReady(e) {
    e.component.option('selectedIndex', 0);
  }

  onBetreuungsArtValueChanged(e) {
    this.betreuungsZeitDataSource = this.configService.getKatalog('BetreuungsZeitKatalog').filter((x) => x.beziehungen.includes(e.value));

    if (!this.betreuungsZeitDataSource.find((x) => x.id === this.formData.searchBetreuungsZeit)) {
      this.formData.searchBetreuungsZeit = undefined;
    }
    this.changeFilter(e);
  }

  onFilterValueChanged(e) {
    this.changeFilter(e);
  }

  changeFilter(e) {
    const token = btoa(encodeURIComponent(JSON.stringify(this.formData)));

    if (this.formData.searchBetreuungsArt) {
      this.storageService.saveToLocale('searchBetreuungsArt', this.formData.searchBetreuungsArt);
    }
    if (this.formData.searchBetreuungsZeit) {
      this.storageService.saveToLocale('searchBetreuungsZeit', this.formData.searchBetreuungsZeit);
    }

    this.urlService
      .refreshQueryParams({
        s: token,
      })
      .then(() => {
        this.setFilterText();
        this.load();
      });
  }

  onRangeSliderChanged(e) {
    if (this.rangeSliderTimeout) {
      clearTimeout(this.rangeSliderTimeout);
    }
    this.rangeSliderTimeout = setTimeout(() => {
      this.load();

      if (this.mapSearchRadius <= 2) {
        this.map.setZoom(14);
      } else if (this.mapSearchRadius <= 4) {
        this.map.setZoom(13);
      } else if (this.mapSearchRadius <= 8) {
        this.map.setZoom(12);
      } else if (this.mapSearchRadius <= 18) {
        this.map.setZoom(11);
      } else if (this.mapSearchRadius <= 30) {
        this.map.setZoom(10);
      } else {
        this.map.setZoom(9);
      }
    }, 500);
  }

  setInitialCurrentPos() {
    const pos: any = this.storageService.getFromLocale('position');
    if (pos === null) {
      this.addressLat = this.configService.getGlobalSettingAsNumber('defaultLatitude');
      this.addressLon = this.configService.getGlobalSettingAsNumber('defaultLongitude');
    } else {
      this.addressLat = pos.lat;
      this.addressLon = pos.lon;
    }
  }

  format(value) {
    return value + ' km';
  }

  ondragEnd(e) {
    if (e && e.lat && e.lon) {
      this.storageService.saveToLocale('position', { lat: e.lat, lon: e.lon });
      this.addressLat = e.lat;
      this.addressLon = e.lon;

      this.formData.meinStandort = e.display_name;
      this.load();
    }
  }

  onSelected(e) {
    if (e && e.lat && e.lon) {
      if (this.map !== undefined && this.map !== null) {
        this.map.flyTo(e.lat, e.lon);
      }
      this.storageService.saveToLocale('position', { lat: e.lat, lon: e.lon });
      this.addressLat = e.lat;
      this.addressLon = e.lon;

      this.formData.meinStandort = e.display_name;
      this.load();
    }
  }

  colorizeMarker() {
    this.filteredResults.forEach((kita) => {
      this.setItemColor(kita);
    });
  }

  setItemColor(item) {
    if (!this.selectedIds.includes(item.id)) {
      if (item.isAccOpen === true) {
        this.map.setMarkerIcon(item.maerkerId, this.marker_icon_notSelected_open);
      } else {
        this.map.setMarkerIcon(item.maerkerId, this.marker_icon_notSelected_notOpen);
      }
    } else {
      if (item.isAccOpen === true) {
        this.map.setMarkerIcon(item.maerkerId, this.marker_icon_selected_open);
      } else {
        this.map.setMarkerIcon(item.maerkerId, this.marker_icon_selected_notOpen);
      }
    }
  }

  onClickKindAnmelden() {
    this.urlService.naviToPreserveQueryParams('intern/inquire/care');
  }

  onClickKindExtSearch() {
    this.extSearchHidden = !this.extSearchHidden;
    let prc2 = window.document.getElementsByClassName('ext-search-container')[0];
    if (this.extSearchHidden) {
      prc2.classList.remove('showing-extended');
    } else {
      prc2.classList.add('showing-extended');
    }

    setTimeout(() => {
      this.setScrollViewHeight();
      let prc = window.document.getElementById('search-page-result-container');

      if (prc) {
        prc.scroll({ top: 0, left: 0, behavior: 'smooth' });
      }
    }, 10);
  }

  formatSearchRadius(value) {
    return `${value} km`;
  }
}
